module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/102/assets/images/8adccb947c49a16a289666ea7553998b.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/ico_participation.svg
// module id = Ryuq
// module chunks = 0